module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Opret person på " + _vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" Vælg personale ")]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "user",
      "calendarIdsToHide": _vm.calendarIdsToHide,
      "showTags": false,
      "preSelectedItems": _vm.userCalendarIds,
      "showCreateButton": false
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [(!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f10bee34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/CreateSubject/CreateSubject.vue
// module id = 1776
// module chunks = 1